import { useInjection } from "@linkfluence/core/di";
import { useQuery } from "@tanstack/react-query";
import { ProjectRepo, ProjectRepositoryUID } from "../repositories/ProjectRepo";

export function useBlockedAuthors(projectId: number) {
  const repository = useInjection<ProjectRepo>(ProjectRepositoryUID);

  const {
    data: blockedAuthors,
    isLoading,
    isError,
  } = useQuery(["/blocked-authors/get", { projectId }], () => {
    return projectId ? repository.getProjectBlockedAuthors(projectId) : null;
  });

  return {
    blockedAuthors,
    isLoading,
    isError,
  };
}
